/*--------------------------------------------------------------------------------------------------------------
 *  Copyright (c) insite-gmbh. All rights reserved.
 *  Licensed under the Apache License, Version 2.0. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------------------------*/
import { Component, Input, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Subscription } from 'rxjs/Rx';


@Component({
    selector: 'inax-disabler-overlay',
    templateUrl: './@inax/commonUi/src/disablerOverlay/disablerOverlay.component.html',
    styleUrls: ['./@inax/commonUi/src/disablerOverlay/disablerOverlay.component.css']
})

export class DisablerOverlayComponent implements OnInit {

    @Input() active: boolean = false;
    state = { active: false };
 
    constructor() {}

    ngOnInit(){
        this.state.active = this.active;
        console.log(this.active ? "disablerOverlay active" : "disablerOverlay NOT active");
    }

}